import { Briefcase, HeadphonesIcon, MessageSquare, Target, Globe } from 'lucide-react';

export const talentExamples = [
  {
    role: 'Assistant(e) virtuel(le) francophone',
    skills: ['Gestion agenda', 'Emails', 'Saisie de données', 'Support administratif'],
    experience: 'Junior à Confirmé',
    costRange: '400 - 700',
    icon: Briefcase
  },
  {
    role: 'Support client',
    skills: ['Téléphone', 'Chat', 'Email', 'Résolution de problèmes'],
    experience: 'Junior à Senior',
    costRange: '450 - 800',
    icon: HeadphonesIcon
  },
  {
    role: 'Community Manager',
    skills: ['Réseaux sociaux', 'Création de contenu', 'Modération', 'Reporting'],
    experience: 'Junior à Confirmé',
    costRange: '500 - 900',
    icon: MessageSquare
  },
  {
    role: 'Media Buyer Junior',
    skills: ['Meta Ads', 'Google Ads', 'Analyse ROI', 'A/B Testing'],
    experience: 'Junior',
    costRange: '600 - 1000',
    icon: Target
  },
  {
    role: 'Développeur Web',
    skills: ['HTML/CSS', 'JavaScript', 'React', 'Node.js', 'PHP'],
    experience: 'Junior à Senior',
    costRange: '700 - 1500',
    icon: Globe
  }
];

export const talentTypes = [
  'Assistant(e) virtuel(le)',
  'Support client',
  'Community Manager',
  'Media Buyer',
  'Développeur Web',
  'Comptable / Gestionnaire',
  'Commercial(e) B2B',
  'Rédacteur / Content Writer',
  'Designer graphique',
  'Autre'
];

export const processSteps = [
  {
    number: '01',
    title: 'Expression de votre besoin',
    description: 'Décrivez le profil recherché : compétences, niveau d\'expérience, disponibilité.'
  },
  {
    number: '02',
    title: 'Sélection rigoureuse',
    description: 'Nous identifions les meilleurs candidats parmi notre vivier qualifié à Madagascar.'
  },
  {
    number: '03',
    title: 'Présentation des profils',
    description: 'Vous recevez une shortlist de 2 à 3 profils pré-validés avec analyse détaillée.'
  },
  {
    number: '04',
    title: 'Intégration accompagnée',
    description: 'Onboarding structuré, suivi de performance et support continu.'
  }
];

export const testimonials = [
  {
    name: 'Sophie Martin',
    role: 'Fondatrice',
    company: 'Digital Agency Paris',
    content: 'Nous avons recruté 3 assistants virtuels via Talent Partner. La qualité des profils et le suivi sont excellents. Nos coûts RH ont baissé de 40%.',
    rating: 5
  },
  {
    name: 'Thomas Dubois',
    role: 'CEO',
    company: 'StartupFlow',
    content: 'Le community manager que nous avons embauché est devenu indispensable. Réactif, créatif et parfaitement francophone. Je recommande vivement.',
    rating: 5
  },
  {
    name: 'Marie Laurent',
    role: 'Directrice Marketing',
    company: 'E-commerce Plus',
    content: 'Processus de recrutement rapide et efficace. En 72h nous avions une shortlist de candidats qualifiés. Le support est toujours disponible.',
    rating: 5
  }
];

export const stats = [
  { value: '150+', label: 'Talents placés' },
  { value: '98%', label: 'Clients satisfaits' },
  { value: '72h', label: 'Délai moyen de présentation' },
  { value: '40%', label: 'Économies moyennes' }
];

export const faqItems = [
  {
    question: 'Comment fonctionne le processus de recrutement ?',
    answer: 'Vous nous décrivez votre besoin, nous sélectionnons les meilleurs profils de notre vivier, vous recevez 2-3 candidats pré-validés sous 72h, puis nous accompagnons l\'intégration.'
  },
  {
    question: 'Quels types de profils proposez-vous ?',
    answer: 'Nous proposons des assistants virtuels, support client, community managers, media buyers, développeurs web, comptables, commerciaux B2B, rédacteurs et designers graphiques.'
  },
  {
    question: 'Quels sont les tarifs ?',
    answer: 'Les salaires varient selon le profil : de 400€/mois pour un assistant junior à 1500€/mois pour un développeur senior. Nous établissons un devis personnalisé selon vos besoins.'
  },
  {
    question: 'Comment sont sélectionnés les talents ?',
    answer: 'Chaque candidat passe par un processus rigoureux : tests techniques, évaluation du niveau de français (oral et écrit), analyse comportementale et vérification des références.'
  },
  {
    question: 'Quelle est la différence de fuseau horaire ?',
    answer: 'Madagascar est en GMT+3, soit seulement 1 à 2 heures de décalage avec la France selon la saison. La collaboration en temps réel est donc facilitée.'
  },
  {
    question: 'Que se passe-t-il si le profil ne convient pas ?',
    answer: 'Nous offrons une garantie de remplacement gratuit pendant la période d\'essai. Si le talent ne correspond pas à vos attentes, nous vous présentons une alternative sans frais.'
  },
  {
    question: 'Comment se passe la gestion administrative ?',
    answer: 'Nous gérons l\'ensemble des aspects administratifs et contractuels. Vous recevez une facture mensuelle unique, sans complexité RH supplémentaire.'
  },
  {
    question: 'Les talents sont-ils formés ?',
    answer: 'Oui, tous nos talents sont diplômés et expérimentés. Nous proposons également des formations complémentaires selon les besoins spécifiques de chaque mission.'
  }
];
